<script>
import { ITooltip } from "@inkline/inkline/src/components";
import { isMobile } from '@inkline/inkline/src/helpers/isMobile';

export default {
    components: {
        ITooltip
    },
    data() {
        return {
            clicks: 0,
            isMobile: isMobile()
        };
    },
    computed: {
        organizationName() {
            return this.$store.getters.organization?.displayName ||
                this.$store.getters.organization?.name;
        },
        signer() {
            return this.$store.getters.signer;
        },
        verificationType() {
            return this.$store.getters.verification.type;
        },
        layout() {
            return this.$route.query.layout;
        },
        layoutClass() {
            return this.$route.query.layout ? `-${this.$route.query.layout}` : false;
        },
        isBlankLayout() {
            return this.$route.query.layout === 'blank';
        }
    },
    methods: {
        onIconClick() {
            if (this.$route.query.layout !== 'blank') { return; }

            this.clicks += 1;
            if (!this.isMobile || this.clicks === 2) {
                this.$store.dispatch('reset');
            }
        }
    }
}
</script>
